import { axios, createAxiosWithCache } from '@ori/axios';
import md5 from 'crypto-js/md5';
import { TRANSLATIONS_CACHE_MAX_AGE, TRANSLATIONS_ENDPOINT, TRANSLATIONS_QUERY_PARAMETER_NAME } from "../constants";
let axiosInstance;
const ACCEPT_LANGUAGE = 'accept-language';
function assertHeaders(headers) {
  return headers != null && typeof headers === 'object';
}
function getAxios() {
  if (!axiosInstance) {
    axiosInstance = createAxiosWithCache({
      key: ({
        headers,
        url,
        params
      }) => {
        const defaultKey = md5(`${url}_${JSON.stringify(params ?? {})}`).toString();
        if (assertHeaders(headers) && ACCEPT_LANGUAGE in headers) {
          return `${headers[ACCEPT_LANGUAGE]}_${defaultKey}`;
        }
        return defaultKey;
      },
      maxAge: TRANSLATIONS_CACHE_MAX_AGE
    });
  }
  return axiosInstance;
}
export async function fetchTranslations({
  baseUrl,
  currentLanguage,
  keys,
  onError
}) {
  const url = new URL(TRANSLATIONS_ENDPOINT, baseUrl);
  Object.values(keys).forEach(key => url.searchParams.append(TRANSLATIONS_QUERY_PARAMETER_NAME, key));
  if (currentLanguage) {
    url.searchParams.append('sc_lang', currentLanguage);
  }
  try {
    const {
      data
    } = await getAxios().get(url.toString(), {
      headers: {
        ...(currentLanguage && {
          [ACCEPT_LANGUAGE]: currentLanguage
        }),
        // https://github.com/axios/axios/issues/5298
        'Accept-Encoding': 'identity'
      }
    });
    return {
      translations: data
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      onError?.(error);
      return {
        error
      };
    }
    throw error;
  }
}
//# sourceMappingURL=fetchTranslations.js.map